import Item from './Item';

export default class Leaf extends Item {
  constructor({ game, location, data }) {
    super({ game, location, data });

    const ind = Phaser.Math.between(1, 12);
    this.frameName = 'leaf_' + (ind < 10 ? '0' : '') + ind;
  }
}
